module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('nav', {
    staticClass: "navbar navbar-toggleable-md navbar-default fixed-top navbar-inverse",
    attrs: {
      "role": "navigation",
      "id": "applicationbrandbar"
    }
  }, [_c('button', {
    staticClass: "navbar-toggler navbar-toggler-right",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbarNavAltMarkup",
      "aria-controls": "navbarNavAltMarkup",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-icon"
  })]), _vm._v(" "), _c('div', {}, [_c('a', {
    staticClass: "navbar-brand",
    staticStyle: {
      "padding-right": "5rem"
    },
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticStyle: {
      "padding": "0rem"
    },
    attrs: {
      "src": require("../../assets/img/logo-cargillwhite-help.svg"),
      "height": "45px"
    }
  })])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3000ba72", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3000ba72"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/TncTopNavFooter.vue
// module id = 707
// module chunks = 1